import { Pipe, PipeTransform } from "@angular/core";
import { CacheService } from "@shared/services/cache.service";
import { LanguageService } from "@shared/services/language.service";
import { Observable, of } from "rxjs";
import { concatMap } from 'rxjs/operators';

@Pipe({ name: "notApplicablePipe" })
export class NotApplicablePipe implements PipeTransform {

constructor(private cacheService: CacheService, private languageService: LanguageService) { }

  transform(value: any): Observable<string> {
    if(value && value != '') {
        return of(value);
    } else {
        return this.languageService.languageType$.pipe(concatMap((lang: any = 'en') => {
            const json = this.cacheService[lang];
            const text = json["na"];
            return of(text);
        }));
    }
  }
}
